import React from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container,  Grid, Button} from '@mui/material'
import {DocumentTemplateService} from '../../../services';
import CustomDataGrid  from '../../../customUtil/DataGrid';

const columns = [
    {
        field: 'templateName', headerName: 'Name', width: 530,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/templates/document-set/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {field: 'version', headerName: 'Version', width: 130}
]

const Documents = () => {
        const [list, setList] = React.useState([]);
        const history = useHistory();

        React.useEffect(() => {
            DocumentTemplateService.getAll()
                .then((response) => {
                    setList(response.data);
                });
        }, []);

        return (
            <Container>
                <header>
                    <h1>Document Sets</h1>
                </header>                
                    <Grid container spacing={5}>
                    <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/templates/document-set/new')}}>Create New</Button>
                        </Grid>                        
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                               />
                       
                        </Grid>
                    </Grid>              
            </Container>
        );
    }
;

export default Documents;
